// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-header{margin:20px 11px 19px 12px!important;overflow:hidden}", ""]);
// Exports
module.exports = exports;
